export enum CardSection {
  TitleEdit = 'title_edit',
  ActionsDropdown = 'actions_dropdown',
  DragHandle = 'drag_handle',
  ChildBranch = 'child_branch',
  Metadata = 'metadata',
}
